import CornTortillaProduct from 'models/CornTortillaProduct'

export const packagingInitialState = {
  category: CornTortillaProduct.category,
  subCategory: CornTortillaProduct.subCategory,
  Size: CornTortillaProduct.Size,
}
